import { Injectable } from '@angular/core';
import { HttpHandler, HttpRequest, HttpInterceptor, HttpEvent } from '@angular/common/http';
import { StorageService } from './local-storage.service';
import { NgxSpinnerService } from "ngx-spinner";
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/internal/operators';
import { SettingService } from './setting.service';

@Injectable({
  providedIn: 'root'
})
export class BaseURLInterceptor implements HttpInterceptor {
  constructor(private storage: StorageService,private spinner: NgxSpinnerService, private settings:SettingService ) { }
  intercept(req: HttpRequest<any>, next: HttpHandler):Observable<HttpEvent<any>> {
    this.spinner.show() 
    if (req.url.includes('__apiUrl__')) {
    
      var baseUrl=req.url.split("__apiUrl__")
      var url= this.settings.getSetting().apiUrl
      req = req.clone({ url : url+baseUrl[1]})
    
    }
 
    const token: string = this.storage.getCurrentToken()
 
    req = req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + token) });
 
   return next.handle(req).pipe(
     finalize(()=>this.spinner.hide())
   )
  }
}